@use "../../../src/styles/Colors.scss" as Colors;
@use "../../../src/styles/Constants.scss" as Constants;

$var-border: 1px solid Colors.$col-greyConnection;
$var-shadow: 0 2px 2px 0 Colors.$col-shadow;
$var-table-header-height: 64px;

.tree {
	width: 100%;
	padding: 0;
	border-radius: Constants.$val-borderRadius;
	border: $var-border;
	-webkit-box-shadow: $var-shadow;
	box-shadow: $var-shadow;

	&__loading-indicator {
		background: Colors.$col-white;
		align-items: center;
		border-radius: Constants.$val-borderRadius;
		display: flex;
		align-items: center;
		height: $var-table-header-height + 1px;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		border-bottom: $var-border;
		justify-content: center;
	}
}
